import React, { useState, useEffect } from "react";

const VALID_USERNAME = "ngotruskanuk";
const VALID_PASSWORD = "Anuk@789$";

const LockIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const PlusIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const EditIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
  </svg>
);

const TrashIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 6h18" />
    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
  </svg>
);

const UploadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const LogoutIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

function AdminPrograms() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authData, setAuthData] = useState({ username: "", password: "" });
  const [authError, setAuthError] = useState("");
  const [programsList, setProgramsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [successBanner, setSuccessBanner] = useState("");
  const [errorBanner, setErrorBanner] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    title: "", desc: "", img1: "", img2: "", img3: "", img4: ""
  });

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (token === 'authenticated') {
      setIsAuthenticated(true);
      loadPrograms();
    }
  }, []);

  const loadPrograms = () => {
    try {
      const stored = localStorage.getItem('programs');
      if (stored) {
        setProgramsList(JSON.parse(stored));
      } else {
        setProgramsList([]);
      }
    } catch {
      setProgramsList([]);
    }
  };

  const savePrograms = (programs) => {
    localStorage.setItem('programs', JSON.stringify(programs));
    setProgramsList(programs);
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    setAuthError("");
    setLoading(true);

    setTimeout(() => {
      if (authData.username === VALID_USERNAME && authData.password === VALID_PASSWORD) {
        localStorage.setItem('adminToken', 'authenticated');
        setIsAuthenticated(true);
        loadPrograms();
      } else {
        setAuthError("Invalid credentials. Please check your username and password.");
      }
      setLoading(false);
    }, 800);
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    setIsAuthenticated(false);
    setAuthData({ username: "", password: "" });
    setProgramsList([]);
    setErrorBanner("");
    setSuccessBanner("");
  };

  const handleCompressedFileSelection = (e, imgSlotKey) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      setErrorBanner(`Image "${file.name}" is ${(file.size / 1024 / 1024).toFixed(1)}MB — very large. Will compress heavily.`);
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const MAX_WIDTH = 800;
        let width = img.width;
        let height = img.height;

        if (width > MAX_WIDTH) {
          height = Math.floor((height * MAX_WIDTH) / width);
          width = MAX_WIDTH;
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.drawImage(img, 0, 0, width, height);
        }

        const compressedBase64 = canvas.toDataURL("image/jpeg", 0.55);
        const sizeMB = (compressedBase64.length * 0.75 / 1024 / 1024).toFixed(2);

        if (parseFloat(sizeMB) > 2.5) {
          setErrorBanner(`Warning: ${imgSlotKey} is still ${sizeMB}MB after compression. All 4 images must total under 12MB.`);
        } else {
          setErrorBanner("");
        }

        setFormData(prev => ({ ...prev, [imgSlotKey]: compressedBase64 }));
      };
    };
    reader.onerror = () => {
      setErrorBanner("Failed to read image file. Please try another image.");
    };
  };

  const handleTextChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleProgramSubmit = (e) => {
    e.preventDefault();
    setErrorBanner("");
    setSuccessBanner("");

    if (!formData.title.trim()) return setErrorBanner("Title is required.");
    if (!formData.desc.trim()) return setErrorBanner("Description is required.");
    if (!formData.img1 || !formData.img2 || !formData.img3 || !formData.img4) {
      return setErrorBanner("Please select all 4 images before submitting.");
    }

    const images = [formData.img1, formData.img2, formData.img3, formData.img4];
    const totalSizeMB = images.reduce((sum, img) => sum + img.length, 0) * 0.75 / 1024 / 1024;

    if (totalSizeMB > 12) {
      return setErrorBanner(
        `Images total ${totalSizeMB.toFixed(1)}MB — too large. Please use smaller images (each image should be under 2MB).`
      );
    }

    setLoading(true);

    setTimeout(() => {
      try {
        const payload = {
          title: formData.title.trim(),
          desc: formData.desc.trim(),
          images,
        };

        let updated;
        if (isEditing && editingId) {
          updated = programsList.map(p =>
            p._id === editingId ? { ...p, ...payload } : p
          );
          setSuccessBanner("✓ Initiative updated successfully!");
        } else {
          const newProgram = {
            _id: Date.now().toString(36) + Math.random().toString(36).slice(2, 8),
            ...payload,
            createdAt: new Date().toISOString(),
          };
          updated = [newProgram, ...programsList];
          setSuccessBanner("✓ Initiative published successfully!");
        }

        savePrograms(updated);
        handleCancelEdit();
      } catch {
        setErrorBanner("Operation failed. Please try again.");
      }
      setLoading(false);
      setTimeout(() => setSuccessBanner(""), 5000);
    }, 600);
  };

  const handleEditTrigger = (record) => {
    setFormData({
      title: record.title,
      desc: record.desc,
      img1: record.images[0] || "",
      img2: record.images[1] || "",
      img3: record.images[2] || "",
      img4: record.images[3] || "",
    });
    setIsEditing(true);
    setEditingId(record._id);
    setErrorBanner("");
    setSuccessBanner("");
    window.scrollTo({ top: 150, behavior: "smooth" });
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditingId(null);
    setFormData({ title: "", desc: "", img1: "", img2: "", img3: "", img4: "" });
  };

  const handleProgramDelete = (id) => {
    if (!window.confirm("Permanently delete this program?")) return;
    setLoading(true);
    setErrorBanner("");

    setTimeout(() => {
      try {
        const updated = programsList.filter(p => p._id !== id);
        savePrograms(updated);
        setSuccessBanner("✓ Initiative deleted.");
        if (editingId === id) handleCancelEdit();
      } catch {
        setErrorBanner("Delete failed. Please try again.");
      }
      setLoading(false);
      setTimeout(() => setSuccessBanner(""), 5000);
    }, 400);
  };

  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #111827 100%)',
      padding: '0 1rem',
    },
    loginCard: {
      width: '100%',
      maxWidth: '28rem',
      backgroundColor: '#ffffff',
      borderRadius: '1rem',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
      overflow: 'hidden',
    },
    accentBar: {
      height: '0.375rem',
      background: 'linear-gradient(90deg, #f59e0b, #f97316, #ef4444)',
    },
    cardContent: {
      padding: '2rem',
    },
    iconContainer: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '4rem',
      height: '4rem',
      borderRadius: '9999px',
      background: 'linear-gradient(135deg, #fef3c7, #ffedd5)',
      color: '#d97706',
      marginBottom: '1rem',
      boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)',
    },
    heading: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#1e293b',
      letterSpacing: '-0.025em',
      marginBottom: '0.5rem',
    },
    subtext: {
      fontSize: '0.875rem',
      color: '#64748b',
    },
    errorBox: {
      marginBottom: '1.25rem',
      padding: '0.75rem 1rem',
      borderRadius: '0.75rem',
      backgroundColor: '#fef2f2',
      border: '1px solid #fecaca',
      color: '#b91c1c',
      fontSize: '0.875rem',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '0.5rem',
    },
    formGroup: {
      marginBottom: '1.25rem',
    },
    label: {
      display: 'block',
      fontSize: '0.75rem',
      fontWeight: '600',
      color: '#475569',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      marginBottom: '0.5rem',
    },
    input: {
      width: '100%',
      padding: '0.75rem 1rem',
      borderRadius: '0.75rem',
      border: '1px solid #e2e8f0',
      backgroundColor: '#f8fafc',
      color: '#1e293b',
      fontSize: '0.875rem',
      outline: 'none',
      transition: 'all 0.2s',
    },
    submitButton: {
      width: '100%',
      padding: '0.875rem',
      borderRadius: '0.75rem',
      fontWeight: '600',
      fontSize: '0.875rem',
      color: '#ffffff',
      background: 'linear-gradient(90deg, #f59e0b, #ea580c)',
      border: 'none',
      cursor: 'pointer',
      boxShadow: '0 10px 15px -3px rgba(249, 115, 22, 0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
      transition: 'all 0.2s',
    },
    footer: {
      marginTop: '1.5rem',
      textAlign: 'center',
      fontSize: '0.75rem',
      color: '#94a3b8',
    },
    dashboard: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f8fafc, #f9fafb, #f4f4f5)',
    },
    header: {
      background: 'linear-gradient(90deg, #0f172a, #1e293b, #111827)',
      color: '#ffffff',
      boxShadow: '0 20px 25px -5px rgba(15, 23, 42, 0.2)',
      position: 'sticky',
      top: 0,
      zIndex: 50,
    },
    headerContent: {
      maxWidth: '80rem',
      margin: '0 auto',
      padding: '1rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    badge: {
      padding: '0.25rem 0.75rem',
      borderRadius: '9999px',
      backgroundColor: 'rgba(245, 158, 11, 0.2)',
      color: '#fcd34d',
      fontSize: '0.75rem',
      fontWeight: '700',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      border: '1px solid rgba(245, 158, 11, 0.3)',
    },
    logoutButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      padding: '0.5rem 1rem',
      borderRadius: '9999px',
      backgroundColor: 'rgba(255,255,255,0.1)',
      color: 'rgba(255,255,255,0.9)',
      border: '1px solid rgba(255,255,255,0.1)',
      fontSize: '0.875rem',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'all 0.2s',
    },
    main: {
      maxWidth: '80rem',
      margin: '0 auto',
      padding: '1.5rem 1rem',
    },
    successBanner: {
      marginBottom: '1.25rem',
      padding: '0.875rem 1.25rem',
      borderRadius: '0.75rem',
      backgroundColor: '#ecfdf5',
      border: '1px solid #a7f3d0',
      color: '#047857',
      fontSize: '0.875rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      animation: 'pulse 2s infinite',
    },
    errorBanner: {
      marginBottom: '1.25rem',
      padding: '0.875rem 1.25rem',
      borderRadius: '0.75rem',
      backgroundColor: '#fef2f2',
      border: '1px solid #fecaca',
      color: '#b91c1c',
      fontSize: '0.875rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: '1.5rem',
    },
    formCard: {
      backgroundColor: '#ffffff',
      borderRadius: '1rem',
      boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
      border: '1px solid #f1f5f9',
      overflow: 'hidden',
      position: 'sticky',
      top: '6rem',
    },
    formAccent: {
      height: '0.25rem',
      background: 'linear-gradient(90deg, #f59e0b, #f97316)',
    },
    formContent: {
      padding: '1.25rem',
    },
    listCard: {
      backgroundColor: '#ffffff',
      borderRadius: '1rem',
      boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
      border: '1px solid #f1f5f9',
      overflow: 'hidden',
    },
    listAccent: {
      height: '0.25rem',
      background: 'linear-gradient(90deg, #3b82f6, #6366f1)',
    },
    listContent: {
      padding: '1.25rem',
    },
    listHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '1.5rem',
    },
    programCard: {
      borderRadius: '0.75rem',
      border: '2px solid #f1f5f9',
      overflow: 'hidden',
      marginBottom: '1rem',
      transition: 'all 0.2s',
    },
    programCardActive: {
      border: '2px solid #f59e0b',
      backgroundColor: 'rgba(255,251,235,0.5)',
      boxShadow: '0 4px 6px -1px rgba(251,191,36,0.2)',
    },
    imageGrid: {
      display: 'flex',
      gap: '0.375rem',
      padding: '0.75rem 0.75rem 0',
    },
    thumbnail: {
      height: '5rem',
      width: '5rem',
      objectFit: 'cover',
      borderRadius: '0.5rem',
      border: '1px solid #f1f5f9',
    },
    programBody: {
      padding: '1rem',
    },
    actionBtn: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.375rem',
      padding: '0.5rem 0.75rem',
      borderRadius: '0.5rem',
      fontSize: '0.75rem',
      fontWeight: '500',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.2s',
    },
    emptyState: {
      textAlign: 'center',
      padding: '4rem 0',
    },
    spinner: {
      animation: 'spin 1s linear infinite',
    },
    cardBody: {
      padding: '2.5rem 2rem',
    },
  };

  if (!isAuthenticated) {
    return (
      <div style={styles.container}>
        <div style={styles.loginCard}>
          <div style={styles.accentBar}></div>
          <div style={styles.cardBody}>
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <div style={styles.iconContainer}>
                <LockIcon />
              </div>
              <h2 style={styles.heading}>Admin Management Access</h2>
              <p style={styles.subtext}>Please supply your authorized institutional access keys.</p>
            </div>

            {authError && (
              <div style={styles.errorBox}>
                <span>⚠</span>
                <span>{authError}</span>
              </div>
            )}

            <form onSubmit={handleLoginSubmit}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Authorized Username</label>
                <input
                  type="text"
                  placeholder="Enter username"
                  value={authData.username}
                  onChange={e => setAuthData({ ...authData, username: e.target.value })}
                  required
                  autoComplete="username"
                  style={styles.input}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#f59e0b';
                    e.target.style.boxShadow = '0 0 0 3px rgba(245,158,11,0.2)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Access Password</label>
                <input
                  type="password"
                  placeholder="Enter secure password"
                  value={authData.password}
                  onChange={e => setAuthData({ ...authData, password: e.target.value })}
                  required
                  autoComplete="current-password"
                  style={styles.input}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#f59e0b';
                    e.target.style.boxShadow = '0 0 0 3px rgba(245,158,11,0.2)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                style={{
                  ...styles.submitButton,
                  opacity: loading ? 0.6 : 1,
                  cursor: loading ? 'not-allowed' : 'pointer',
                }}
                onMouseOver={(e) => {
                  if (!loading) {
                    e.target.style.transform = 'scale(1.02)';
                    e.target.style.boxShadow = '0 15px 20px -5px rgba(249,115,22,0.4)';
                  }
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.boxShadow = '0 10px 15px -3px rgba(249,115,22,0.3)';
                }}
              >
                {loading ? (
                  <>
                    <svg style={{ ...styles.spinner, height: '1rem', width: '1rem' }} viewBox="0 0 24 24" fill="none">
                      <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                    Authenticating...
                  </>
                ) : (
                  "Authenticate Connection"
                )}
              </button>
            </form>

            <p style={styles.footer}>
              Institutional access only • Encrypted connection
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.dashboard}>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.8; }
        }
      `}</style>
      
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <span style={styles.badge}>Secure Portal</span>
            <h1 style={{ fontSize: '1.125rem', fontWeight: '700', letterSpacing: '-0.025em', display: 'none' }} className="header-title">
              Programs Database Management
            </h1>
            <h1 style={{ fontSize: '1.125rem', fontWeight: '700', letterSpacing: '-0.025em' }} className="header-title-mobile">
              Programs Admin
            </h1>
          </div>
          <button
            onClick={logout}
            style={styles.logoutButton}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.2)';
              e.target.style.borderColor = 'rgba(255,255,255,0.2)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
              e.target.style.borderColor = 'rgba(255,255,255,0.1)';
            }}
          >
            <LogoutIcon />
            <span style={{ display: 'none' }} className="logout-text">Drop Session</span>
          </button>
        </div>
      </header>

      <main style={styles.main}>
        {successBanner && (
          <div style={styles.successBanner}>
            <span style={{ fontSize: '1.125rem' }}>✓</span>
            <span>{successBanner}</span>
          </div>
        )}
        {errorBanner && (
          <div style={styles.errorBanner}>
            <span style={{ fontSize: '1.125rem' }}>⚠</span>
            <span>{errorBanner}</span>
          </div>
        )}

        <div style={styles.grid}>
          <div style={{ gridColumn: 'span 1' }}>
            <div style={styles.formCard}>
              <div style={styles.formAccent}></div>
              <div style={styles.formContent}>
                <div style={{ marginBottom: '1.5rem' }}>
                  <h3 style={{ fontSize: '1.125rem', fontWeight: '700', color: '#1e293b' }}>
                    {isEditing ? "Update Active Initiative" : "Append New Program"}
                  </h3>
                  <p style={{ fontSize: '0.875rem', color: '#64748b', marginTop: '0.25rem' }}>
                    {isEditing
                      ? "Modify attributes to update archives."
                      : "Input parameters to publish updates directly."}
                  </p>
                </div>

                <form onSubmit={handleProgramSubmit}>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>
                      Initiative Title <span style={{ color: '#ef4444' }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="title"
                      placeholder="e.g., Rural Nutrition Outreach"
                      value={formData.title}
                      onChange={handleTextChange}
                      required
                      style={styles.input}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#f59e0b';
                        e.target.style.boxShadow = '0 0 0 3px rgba(245,158,11,0.2)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e2e8f0';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>

                  <div style={styles.formGroup}>
                    <label style={styles.label}>
                      Complete Operational Description <span style={{ color: '#ef4444' }}>*</span>
                    </label>
                    <textarea
                      name="desc"
                      rows={4}
                      placeholder="Detail the scope and objectives of this initiative..."
                      value={formData.desc}
                      onChange={handleTextChange}
                      required
                      style={{
                        ...styles.input,
                        resize: 'none',
                        fontFamily: 'inherit',
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#f59e0b';
                        e.target.style.boxShadow = '0 0 0 3px rgba(245,158,11,0.2)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e2e8f0';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>

                  <div style={styles.formGroup}>
                    <span style={styles.label}>
                      Exactly 4 Images Required <span style={{ color: '#ef4444' }}>*</span>
                    </span>
                    <small style={{ display: 'block', fontSize: '0.75rem', color: '#94a3b8', marginBottom: '0.75rem' }}>
                      Each image will be compressed automatically for optimal storage.
                    </small>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                      {['img1', 'img2', 'img3', 'img4'].map((slot, i) => (
                        <div key={slot}>
                          <input
                            type="file"
                            id={`${slot}-${isEditing ? editingId : 'new'}`}
                            accept="image/*"
                            onChange={(e) => handleCompressedFileSelection(e, slot)}
                            style={{ display: 'none' }}
                          />
                          <label
                            htmlFor={`${slot}-${isEditing ? editingId : 'new'}`}
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '0.75rem',
                              borderRadius: '0.75rem',
                              border: `2px dashed ${formData[slot] ? '#6ee7b7' : '#e2e8f0'}`,
                              backgroundColor: formData[slot] ? '#ecfdf5' : '#f8fafc',
                              cursor: 'pointer',
                              transition: 'all 0.2s',
                              minHeight: '110px',
                            }}
                            onMouseOver={(e) => {
                              if (!formData[slot]) {
                                e.target.style.borderColor = '#fcd34d';
                                e.target.style.backgroundColor = 'rgba(255,251,235,0.4)';
                              }
                            }}
                            onMouseOut={(e) => {
                              if (!formData[slot]) {
                                e.target.style.borderColor = '#e2e8f0';
                                e.target.style.backgroundColor = '#f8fafc';
                              }
                            }}
                          >
                            {formData[slot] ? (
                              <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <img
                                  src={formData[slot]}
                                  alt={`Slot ${i + 1}`}
                                  style={{ maxHeight: '6rem', width: 'auto', borderRadius: '0.5rem', objectFit: 'contain' }}
                                />
                                <span style={{
                                  position: 'absolute',
                                  top: '0.125rem',
                                  right: '0.125rem',
                                  padding: '0.125rem 0.375rem',
                                  borderRadius: '0.375rem',
                                  backgroundColor: '#10b981',
                                  color: '#ffffff',
                                  fontSize: '0.625rem',
                                  fontWeight: '700',
                                }}>
                                  ✓ {i + 1}
                                </span>
                              </div>
                            ) : (
                              <div style={{ textAlign: 'center' }}>
                                <div style={{ color: '#94a3b8', marginBottom: '0.25rem' }}>
                                  <UploadIcon />
                                </div>
                                <span style={{ fontSize: '0.75rem', fontWeight: '500', color: '#64748b' }}>
                                  Photo {i + 1}
                                </span>
                              </div>
                            )}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', paddingTop: '0.5rem' }}>
                    <button
                      type="submit"
                      disabled={loading}
                      style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5rem',
                        padding: '0.75rem 1.25rem',
                        borderRadius: '0.75rem',
                        fontWeight: '600',
                        fontSize: '0.875rem',
                        color: '#ffffff',
                        background: 'linear-gradient(90deg, #f59e0b, #ea580c)',
                        border: 'none',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        boxShadow: '0 10px 15px -3px rgba(249,115,22,0.3)',
                        opacity: loading ? 0.6 : 1,
                        transition: 'all 0.2s',
                      }}
                      onMouseOver={(e) => {
                        if (!loading) {
                          e.target.style.transform = 'scale(0.99)';
                        }
                      }}
                      onMouseOut={(e) => {
                        e.target.style.transform = 'scale(1)';
                      }}
                    >
                      {loading ? (
                        <svg style={{ ...styles.spinner, height: '1rem', width: '1rem' }} viewBox="0 0 24 24" fill="none">
                          <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                        </svg>
                      ) : (
                        <PlusIcon />
                      )}
                      <span>{loading ? "Saving..." : isEditing ? "Save Updates" : "Publish Initiative"}</span>
                    </button>
                    {isEditing && (
                      <button
                        type="button"
                        onClick={handleCancelEdit}
                        style={{
                          padding: '0.75rem 1.25rem',
                          borderRadius: '0.75rem',
                          fontWeight: '500',
                          fontSize: '0.875rem',
                          color: '#475569',
                          backgroundColor: '#f1f5f9',
                          border: '1px solid #e2e8f0',
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                        }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor = '#e2e8f0';
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor = '#f1f5f9';
                        }}
                      >
                        Cancel Edit
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div style={{ gridColumn: 'span 1' }}>
            <div style={styles.listCard}>
              <div style={styles.listAccent}></div>
              <div style={styles.listContent}>
                <div style={styles.listHeader}>
                  <div>
                    <h3 style={{ fontSize: '1.125rem', fontWeight: '700', color: '#1e293b' }}>Active Registry Archives</h3>
                    <p style={{ fontSize: '0.875rem', color: '#64748b', marginTop: '0.25rem' }}>
                      Current live program entries in the database.
                    </p>
                  </div>
                  <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '0.375rem 0.75rem',
                    borderRadius: '9999px',
                    backgroundColor: '#eff6ff',
                    color: '#1d4ed8',
                    fontSize: '0.75rem',
                    fontWeight: '700',
                    border: '1px solid #bfdbfe',
                  }}>
                    {programsList.length} Active
                  </span>
                </div>

                <div style={{ maxHeight: '600px', overflowY: 'auto', paddingRight: '0.25rem' }}>
                  {loading && programsList.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '4rem 0', color: '#94a3b8' }}>
                      <svg style={{ ...styles.spinner, margin: '0 auto 0.75rem', height: '2.5rem', width: '2.5rem', color: '#cbd5e1' }} viewBox="0 0 24 24" fill="none">
                        <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                        <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                      </svg>
                      <p style={{ fontSize: '0.875rem' }}>Loading programs...</p>
                    </div>
                  ) : programsList.length === 0 ? (
                    <div style={styles.emptyState}>
                      <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '4rem',
                        height: '4rem',
                        borderRadius: '9999px',
                        backgroundColor: '#f1f5f9',
                        color: '#cbd5e1',
                        marginBottom: '1rem',
                      }}>
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                          <path d="M12 6v12m-6-6h12" strokeLinecap="round" />
                        </svg>
                      </div>
                      <p style={{ color: '#64748b', fontWeight: '500' }}>Registry empty.</p>
                      <p style={{ color: '#94a3b8', fontSize: '0.875rem', marginTop: '0.25rem' }}>Add your first program using the form.</p>
                    </div>
                  ) : (
                    programsList.map(item => (
                      <div
                        key={item._id}
                        style={{
                          ...styles.programCard,
                          ...(editingId === item._id ? styles.programCardActive : {}),
                        }}
                      >
                        <div style={styles.imageGrid}>
                          {item.images?.slice(0, 4).map((img, i) => (
                            <img
                              key={i}
                              src={img}
                              alt={`Thumb ${i + 1}`}
                              loading="lazy"
                              style={styles.thumbnail}
                            />
                          ))}
                        </div>

                        <div style={styles.programBody}>
                          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '0.75rem' }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <h4 style={{ fontWeight: '700', color: '#1e293b', fontSize: '0.875rem', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {item.title}
                              </h4>
                              <p style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '0.25rem', lineHeight: '1.5', margin: '0.25rem 0' }}>
                                {item.desc?.substring(0, 120)}
                                {item.desc?.length > 120 ? "..." : ""}
                              </p>
                              <p style={{ fontSize: '0.625rem', color: '#94a3b8', marginTop: '0.5rem', margin: '0.5rem 0 0 0' }}>
                                {new Date(item.createdAt).toLocaleDateString("en-US", {
                                  year: "numeric", month: "short", day: "numeric"
                                })}
                              </p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>
                              <button
                                onClick={() => handleEditTrigger(item)}
                                disabled={loading}
                                style={{
                                  ...styles.actionBtn,
                                  color: '#4f46e5',
                                  backgroundColor: '#eef2ff',
                                  border: '1px solid #c7d2fe',
                                  opacity: loading ? 0.5 : 1,
                                  cursor: loading ? 'not-allowed' : 'pointer',
                                }}
                                onMouseOver={(e) => {
                                  if (!loading) {
                                    e.target.style.backgroundColor = '#e0e7ff';
                                  }
                                }}
                                onMouseOut={(e) => {
                                  e.target.style.backgroundColor = '#eef2ff';
                                }}
                              >
                                <EditIcon />
                                <span>Edit</span>
                              </button>
                              <button
                                onClick={() => handleProgramDelete(item._id)}
                                disabled={loading}
                                style={{
                                  ...styles.actionBtn,
                                  color: '#dc2626',
                                  backgroundColor: '#fef2f2',
                                  border: '1px solid #fecaca',
                                  opacity: loading ? 0.5 : 1,
                                  cursor: loading ? 'not-allowed' : 'pointer',
                                }}
                                onMouseOver={(e) => {
                                  if (!loading) {
                                    e.target.style.backgroundColor = '#fee2e2';
                                  }
                                }}
                                onMouseOut={(e) => {
                                  e.target.style.backgroundColor = '#fef2f2';
                                }}
                              >
                                <TrashIcon />
                                <span>Drop</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>  
            </div>
          </div>
        </div>
      </main>

      <footer style={{ marginTop: '3rem', paddingBottom: '2rem', textAlign: 'center', fontSize: '0.75rem', color: '#94a3b8' }}>
        <p>Admin Portal • Institutional Access Only • All data stored locally</p>
      </footer>

      <style>{`
        @media (min-width: 640px) {
          .header-title {
            display: block !important;
          }
          .header-title-mobile {
            display: none !important;
          }
          .logout-text {
            display: inline !important;
          }
        }
        @media (min-width: 1280px) {
          .header-title {
            display: block !important;
          }
        }
      `}</style>
    </div>
  );
}

export default AdminPrograms;